import {apiBase} from './api.config';
export default {
    ws: 'ws://192.168.1.23:10443/v1/ws/vehicle_info',
    login: 'http://192.168.1.23:9443/v1/auth/login',
    logout: 'http://192.168.1.23:9443/v1/auth/logout',
    test: 'http://192.168.1.23:9443',
    menu: apiBase() + 'static/data/menu.json',
    trace: apiBase() + 'http://192.168.1.23:10443/v1/trace/',
    filter: apiBase() + 'http://192.168.1.23:10443/v1/field/filter',
    chart: apiBase() + 'static/data/chart.json',
    poits: apiBase() + 'static/data/poits.json',
    table: apiBase() + 'static/data/table.json',
    jsonVehicle: apiBase() + 'static/data/vehicle.json',
    vehicle: 'http://192.168.1.26:8989/v1/vehicle',
    templet: apiBase() + 'static/data/车辆基本信息模板.xlsx'
};



// WEBPACK FOOTER //
// ./src/Api/index.js